import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';

import i18n from 'i18n-js';

import { listItem } from 'components/banners/DisplayItems';
import AuthButton from 'components/base/AuthButton';
import ContentSections from 'components/base/ContentSections';
import CustomBreadcrumb from 'components/base/CustomBreadcrumb';
import CustomListComponent from 'components/base/CustomListComponent';
import CustomRichTextViewer from 'components/base/CustomRichTextViewer';
import Loading from 'components/base/Loading';
import MembershipInfoCard from 'components/customer/MembershipInfoCard';
import { CustomTitleLabel } from 'components/earning/CustomBaseComponments';
import { PermissionCodes } from 'config/PermissionCodes';

import './CustomerGroupDetail.scss';

function CustomerGroupDetail({ customerGroup, hasUpdatedDefaultValues }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const params = useParams();

  useEffect(() => {
    dispatch({
      type: 'customerGroup/clearData',
    });
    dispatch({
      type: 'customerGroup/getCustomerGroup',
      payload: {
        id: params.id,
      },
    });
  }, [dispatch, params.id]);

  const getItemOrderList = (datas) => {
    if (!datas || !datas.length) {
      return '-';
    }
    return datas.map((data) => <li>{data?.label}</li>);
  };

  const sections = [
    <>
      <label className="create-section-title">{'INFORMATION'}</label>
      {listItem(i18n.t('name'), customerGroup?.name)}
      <CustomTitleLabel title={i18n.t('description_optional')} />
      <CustomRichTextViewer initialValue={customerGroup?.description} />
      {listItem(
        'Show in Customer profile',
        customerGroup?.displayShowInCustomerProfile,
      )}
      <CustomTitleLabel
        title={
          customerGroup?.customers?.length > 0
            ? `Target customer (${customerGroup?.customers?.length})`
            : 'Target customer'
        }
      />
      <div className="target-customer-list-container customer-detail">
        <div className="target-customer-list">
          {getItemOrderList(customerGroup?.customers)}
        </div>
      </div>
    </>,
    <MembershipInfoCard
      title={'GENERAL'}
      data={customerGroup}
      fields={[
        [
          {
            title: 'Creation time',
            field: 'displayCreationDate',
          },
        ],
        [
          {
            title: 'Last modified time',
            field: 'displayLastModifiedDate',
          },
        ],
        [
          {
            title: 'Last modified by',
            field: 'displayLastModifiedBy',
          },
        ],
      ]}
    />,
  ];

  const tabs = [
    {
      name: 'Detail',
      content: !hasUpdatedDefaultValues ? (
        <Loading />
      ) : (
        <ContentSections sections={sections} hidePreview={true} />
      ),
    },
  ];

  const buttons = [
    <AuthButton
      className="btn-further"
      onClick={() => {
        history.push({
          pathname: 'edit/',
        });
      }}
      requires={PermissionCodes.changeCustomerGroup}
    >
      Edit
    </AuthButton>,
  ];

  const [activeTab, setActiveTab] = useState(tabs[0].name);

  return (
    <div className="customer">
      <CustomListComponent
        caution={{
          detail: '',
          title: customerGroup.name,
        }}
        defaultActiveKey={activeTab}
        breadcrumb={<CustomBreadcrumb name={customerGroup.name} />}
        buttons={buttons}
        tabs={tabs}
        onTabChange={(key) => {
          setActiveTab(key);
        }}
      />
    </div>
  );
}

const mapPropsToState = (state) => ({
  customerGroup: state.customerGroup.selectedCustomerGroup,
  hasUpdatedDefaultValues: state.customerGroup.hasUpdatedDefaultValues,
});

export default connect(mapPropsToState)(CustomerGroupDetail);
